export default __webpack_public_path__ + "static/media/12_CAMP_OUGANDA_02-min.58a15913.jpg";